import { forwardRef, Fragment } from "react";
import Box from "@mui/material/Box";
import classes from "./PrintContent.module.css";
import Typography from "@mui/material/Typography";
import {
  DateField,
  NumberField,
  RecordContextProvider,
  // usePermissions,
} from "react-admin";
import splitArrayToChunks from "../../../utils/splitArrayToChunks";

const PrintContent = forwardRef((props, ref) => {
  // eslint-disable-line max-len
  // const { permissions, isLoading } = usePermissions();

  return (
    <Box
      component="div"
      sx={{
        display: "none",
      }}
    >
      <Box ref={ref}>
        <style type="text/css" media="print">
          {`@page {
              width: 215.9mm;
              height: 139.7mm;
              size: 8.5in 5.5in portrait;
              margin: 0;
            }
            html, body {
              width: 215.9mm;
              height: 100%;
            }
            .page-break {
              display: block;
              page-break-after: always;
              break-after: page;
              height: 0;
            }
            .page-break:last-child {
              page-break-after: auto;
              break-after: auto;
            }
            .big-back::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-image: url('/atena-tiles.png');
              background-repeat: no-repeat;
              background-position: 50% 24%;
              background-size: 20% auto;
              opacity: 0.2;
              z-index: -1;
            }
          `}
        </style>
        {splitArrayToChunks(props.record.bad_debt_correction_items, 5).map(
          (arr, i, ori) => {
            // TODO semua print content strukturnya perlu ikutin ini
            return (
              <Fragment key={i}>
                <Box
                  className="big-back"
                  sx={
                    i > 0
                      ? {
                          position: "relative",
                          overflow: "hidden",
                          fontSize: "12px",
                          py: 2,
                          px: 2,
                          display: "flex",
                          flexDirection: "column",
                          height: "139.7mm",
                          boxSizing: "border-box",
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }
                      : {
                          position: "relative",
                          overflow: "hidden",
                          fontSize: "12px",
                          py: 2,
                          px: 2,
                          display: "flex",
                          flexDirection: "column",
                          height: "139.7mm",
                          boxSizing: "border-box",
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }
                  }
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        textTransform: "uppercase",
                        fontFamily: "inherit",
                      }}
                    >
                      {props.record.company.name}
                    </Typography>
                    <Box>
                      <Typography
                        variant="subtitle2"
                        component="span"
                        sx={{
                          pr: 1,
                          fontFamily: "inherit",
                        }}
                      >
                        Print date:
                      </Typography>
                      <RecordContextProvider value={props.record}>
                        <DateField
                          source="print_date"
                          sx={{
                            fontWeight: "inherit",
                            fontSize: "12px",
                            fontFamily: "inherit",
                          }}
                          options={{
                            year: "numeric",
                            month: "short",
                            day: "2-digit",
                          }}
                        ></DateField>
                      </RecordContextProvider>
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      mb: 1.5,
                      textTransform: "uppercase",
                      borderBottom: "1px solid #000",
                      textAlign: "center",
                      fontFamily: "inherit",
                    }}
                  >
                    koreksi piutang bad debt
                  </Typography>
                  <table className={classes.headerSj}>
                    <thead>
                      <tr>
                        <th rowSpan={5} style={{ width: "70%" }}>
                          <div
                            style={{ fontWeight: "400", marginBottom: "6px" }}
                          >
                            KEPADA YTH:{" "}
                          </div>
                          <div
                            style={{ paddingLeft: "16px", fontWeight: "400" }}
                          >
                            {props.record.customer.code}
                          </div>
                          <div style={{ paddingLeft: "16px" }}>
                            {props.record.customer.name}
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th>No. Voucher</th>
                        <th>:</th>
                        <th>{props.record.code}</th>
                      </tr>
                      <tr>
                        <th>Tanggal</th>
                        <th>:</th>
                        <th>
                          <RecordContextProvider value={props.record}>
                            <DateField
                              source="date"
                              sx={{ fontWeight: "inherit", fontSize: "12px" }}
                              options={{
                                year: "numeric",
                                month: "short",
                                day: "2-digit",
                              }}
                            ></DateField>
                          </RecordContextProvider>
                        </th>
                      </tr>
                    </thead>
                  </table>
                  <Typography
                    variant="caption"
                    sx={{
                      mt: 1.5,
                      mb: 1,
                      fontFamily: "inherit",
                    }}
                  >
                    Keterangan: {props.record.note}
                  </Typography>
                  <table className={`${classes.tableSj} ${classes.badDebtCorrectionItems}`}>
                    <thead>
                      <tr>
                        <th>No. Bukti surat Jalan</th>
                        <th>Kode COA</th>
                        <th style={{ textAlign: "right" }}>Nominal</th>
                      </tr>
                    </thead>
                    <tbody>
                      {arr.map((obj, idx) => {
                        return (
                          <tr
                            key={
                              obj.id +
                              (Math.random() + 1).toString(36).substring(7)
                            }
                          >
                            <td>{obj.bad_debt_item.sale.code}</td>
                            {idx === 0 && (
                              <td rowSpan={arr.length}>
                                {props.record.bad_debt_correction_journals.map(
                                  (cdcj, ix) => {
                                    return idx === 0 ? (
                                      <div>
                                        {cdcj.chart_of_account.code +
                                          " " +
                                          cdcj.chart_of_account.name}
                                      </div>
                                    ) : null;
                                  }
                                )}
                              </td>
                            )}
                            <td style={{ textAlign: "right" }}>
                              <RecordContextProvider value={obj}>
                                <NumberField
                                  source="amount"
                                  sx={{
                                    fontWeight: "inherit",
                                    fontSize: "12px",
                                    fontFamily: "inherit",
                                  }}
                                ></NumberField>
                              </RecordContextProvider>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            textAlign: "right",
                            verticalAlign: "baseline",
                            fontWeight: "bold",
                            borderRight: "none",
                          }}
                        >
                          Total:
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <RecordContextProvider value={props.record}>
                            <NumberField
                              source="total"
                              sx={{
                                fontWeight: "inherit",
                                fontSize: "12px",
                                fontFamily: "inherit",
                              }}
                            ></NumberField>
                          </RecordContextProvider>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <Typography
                    variant="caption"
                    sx={{
                      mt: "auto",
                      textTransform: "capitalize",
                      fontFamily: "inherit",
                    }}
                  >
                    {"Terbilang: # " +
                      props.record.total_in_words +
                      " Rupiah #"}
                  </Typography>
                  <table
                    style={{ marginTop: "8px" }}
                    className={classes.tableACC}
                  >
                    <thead>
                      <tr>
                        <th>Mengetahui</th>
                        <th colSpan={2}>Pemeriksa</th>
                        <th>Pelaksana</th>
                        <th>Pelanggan</th>
                      </tr>
                      <tr>
                        <th
                          style={{ textTransform: "uppercase", width: "16.6%" }}
                        >
                          Kepala Depo
                        </th>
                        <th
                          style={{ textTransform: "uppercase", width: "16.6%" }}
                        >
                          Akunting
                        </th>
                        <th
                          style={{ textTransform: "uppercase", width: "16.6%" }}
                        >
                          Administrasi
                        </th>
                        <th
                          style={{
                            textTransform: "uppercase",
                            borderBottom: "none",
                            width: "16.6%",
                          }}
                        ></th>
                        <th
                          style={{
                            textTransform: "uppercase",
                            borderBottom: "none",
                            width: "16.6%",
                          }}
                        ></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <div>(................)</div>
                          <div>FINANCE</div>
                        </td>
                        <td>
                          <div>(................)</div>
                          <div>CAP TOKO</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Box>
                <div className="page-break" />
              </Fragment>
            );
          }
        )}
      </Box>
    </Box>
  );
});
export default PrintContent;
